import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));

//
// PGWebSdk URL must be set dynamically based on the environment (Stage, Getsbet, Conti),
// since the sandbox is built within the pipeline. As a result, we need to load the script
// dynamically and wait for it to load before rendering the app.
let intervalId = null;
intervalId = setInterval(() => {
  if (window.__PGWebSdk) {
    clearInterval(intervalId);
    root.render(<App />);
  }
}, 1000);
